var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRightUp = function SvgIconRightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.793 3.793a1 1 0 0 1 1.414 0l4.5 4.5a1 1 0 0 1-1.414 1.414L17.5 6.914V18a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h12.5V6.914l-2.793 2.793a1 1 0 0 1-1.414-1.414z"
  })));
};
export default SvgIconRightUp;